import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {AppComponent} from '../app.component';
import {Router } from '@angular/router';
import { SortListService } from '../services/sort-list.service';

@Component({
  selector: 'app-assign-darshan-type',
  templateUrl: './assign-darshan-type.component.html',
  styleUrls: ['./assign-darshan-type.component.scss']
})
export class AssignDarshanTypeComponent implements OnInit {
  form: FormGroup;
  formMode = 'Add';
  allDarshanTypes = [];
  userList = [];

  constructor(
    private _formBuilder: FormBuilder, 
    private apiService : ApiService, 
    private appComponent: AppComponent, 
    private router: Router,
    private sortListService: SortListService

    ) {}

  ngOnInit() {
    this.getAllUserList();
    this.getAllDarshanTypes();
    this.createForm();
  }


  createForm() {
    this.form = this._formBuilder.group({
      darshan_type_id: ['', [Validators.required]],
      user_id: ['', [Validators.required]],
    });
   
  }
  

  getAllUserList() {
    this.apiService.getDataFromServer('/users').subscribe(
      res => {
        // this.userList = res['data'];
        this.sortListService.sortList(res['data'],'username').then(res => {
          this.userList = res;
        });
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllDarshanTypes() {
    this.apiService.getDataFromServer('/darshan_types').subscribe(
      res => {
        // this.allDarshanTypes = res['data'];
        this.sortListService.sortList(res['data'],'name').then(res => {
          this.allDarshanTypes = res;
        });
        
      },
      err => {
        console.log(err);
      }
    );
  }



  saveData() {
    const formObj = this.form.getRawValue();

    if(this.formMode == 'Add') {
      this.appComponent.showLoader();
      this.apiService.postDataToServer('/darshan_type_user', formObj).subscribe(
        res => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(res['message'], 'success');
          this.createForm();
          this.close();
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
    }
    //  else {
    //   this.appComponent.showLoader();
    //   this.apiService.putDataToServer(`/visitors/${formObj.id}`, formObj).subscribe(
    //     res => {
    //       this.appComponent.hideLoader();
    //       this.appComponent.showMessageAlert(res['message'], 'success');
    //       this.router.navigate(['/registration-list']);
    //       this.createForm();
    //     },
    //     err => {
    //       this.appComponent.hideLoader();
    //       this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
    //       console.log(err);
    //     }
    //   );
    // }
  }

  close() {
    this.router.navigate(['/user-to-darshan-type-mapping']);

  }

}

